export enum TableRowMode {
    NONE = "none",
    ADD = "add",
    UPDATE = "update",
    SEARCH = "search",
    QUICK_ADD = "quickAdd"
}